
//路由层
const View = resolve => require(["../../components/View.vue"], resolve);

// 订单中心
// |
// |——创建订单
// |——订单管理
// |——订单日志
// |——交易记录

/**
 *  订单模块 路由表
 */
const orderRouter = {
    path: 'order',
    name: "订单中心",
    component: View,
    children: [

        //企业
        {
            path: "form",
            component: () => import("@/view/logger/order/table"),
            name: "企业/订单管理"
        },
        // {
        //     path: "list",
        //     component: () => import("@/view/order/orderList"),
        //     name: "购买订单"
        // },
        {
            path: "list",
            component: () => import("@/view/order/orderList"),
            name: "订单管理"
        },
        {
            path: "oderLog",
            component: () => import("@/view/logger/order/table"),
            name: "订单日志"
        },
        {
          path: "oderBindLog",
          component: () => import("@/view/logger/order/BindLogTable.vue"),
          name: "换绑日志"
        },
        {
            path: "payLog",
            component: () => import("@/view/logger/payLog/table"),
            name: "订单支付日志"
        },
      {
        path: "transaction",
        component: () => import("@/view/store/transaction"),
        name: "交易日志"
      },
      {
        path: "transaction/:account",
        component: () => import("@/view/store/transaction"),
        name: "交易日志"

      },
      {
        path: "rebate",
        component: () => import("@/view/store/rebate"),
        name: "返利明细"
      },


    ]
}

export default orderRouter;



// WEBPACK FOOTER //
// ./src/router/modules/order.js